import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import useSmartBrowserPresenter from '../Panels/PrimaryNavigationColumn/SmartBrowser/SmartBrowser.presenter';
import SmartBrowserFormModalContentSignIn from './SmartBrowserFormModalContentSignIn';
import SmartBrowserFormModalContentSignUp from './SmartBrowserFormModalContentSignUp';
import { SmartCloseButton } from './SmartCloseButton';

const StyledSmartBrowserModalContent = styled.ScrollView`
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
  border-radius: 40px;
  overflow: hidden;
  flex: 1;
  background-color: white;
`;

const SmartBrowserFormModal: FC = () => {
  const { isSignUpMode, handleCloseModal } = useSmartBrowserPresenter();

  const getMaxHeight = (): number => (isSignUpMode ? 500 : 700);
  const { height: windowHeight } = useWindowDimensions();
  const height = Math.min(windowHeight - 70, getMaxHeight()); // just put enough vertical space

  if (isSignUpMode) {
    return (
      <View style={[styles.wrapper, { height }]}>
        <StyledSmartBrowserModalContent>
          <SmartBrowserFormModalContentSignUp />
        </StyledSmartBrowserModalContent>
        <SmartCloseButton onPress={handleCloseModal} />
      </View>
    );
  }

  return (
    <View style={[styles.wrapper, { height }]}>
      <StyledSmartBrowserModalContent>
        <SmartBrowserFormModalContentSignIn />
      </StyledSmartBrowserModalContent>
      <SmartCloseButton onPress={handleCloseModal} />
    </View>
  );
};

export default observer(SmartBrowserFormModal);

const styles = StyleSheet.create({
  wrapper: {
    width: '90%',
    maxWidth: 390,
  },
});
